import { noteActions, patientActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [noteActions.loadInProgNoteRequest]: (state, action) => {
        let noteType = parseInt(action.payload.noteId.split("_")[0]);

        var note = {
            id: action.payload.noteId,
            loading: true,
            savingFinal: false,
            isChargeExist: false,
            areYouSure: false,
            alTemplateVisible: false,
            goalTemplateVisible: false,
            savePanelVisible: false,
            alTmpno: undefined,
            alTemplateAllSelected: false,
            lastDeletedAlTemplate: undefined,
            selectedGoal: undefined,
            saveGoalFavoriteVisible: false,
            validationVisible: false,
            computedChargesVisible: false,
            noChargesVisible: false,
            limberOutcomesLoading: false,
            sub_severityVisible: action.payload.isWc,
            sub_motivationVisible: action.payload.isWc,
            sub_fitnessVisible: action.payload.isWc,
            sub_phaseVisible: action.payload.isWc,
            subj_equipVisible: false,
            sub_med_hist_sleepVisible: false,
            sub_headachesVisible: false,
            sub_depressVisible: false,
            assessment_orthosisVisible: false,
            obj_obs_accjointmobVisible: false,
            obj_obs_circumVisible: false,
            obj_obs_functestVisible: false,
            obj_obs_gaitVisible: false,
            obj_obs_generalVisible: false,
            obj_obs_postureVisible: false,
            obj_obs_palpationVisible: false,
            obj_spec_tests_ankleVisible: false,
            obj_spec_tests_behaviorVisible: false,
            obj_spec_tests_cervicalVisible: false,
            obj_spec_tests_cervicalmyelopathycprVisible: false,
            obj_spec_tests_cervicalradiculopathyclustertestVisible: false,
            obj_spec_tests_closedcervicalfracturecprVisible: false,
            obj_spec_tests_cognitionVisible: false,
            obj_spec_tests_commentsVisible: false,
            obj_spec_tests_concussionVisible: false,
            obj_spec_tests_coordinationVisible: false,
            obj_spec_tests_cranialnervetestingVisible: false,
            obj_spec_tests_dtrVisible: false,
            obj_spec_tests_elbowVisible: false,
            obj_spec_tests_fullthicknessrotatorcufftearclusterVisible: false,
            obj_spec_tests_handVisible: false,
            obj_spec_tests_hearinglLossVisible: false,
            obj_spec_tests_hipVisible: false,
            obj_spec_tests_impingementclustertestVisible: false,
            obj_spec_tests_kneeVisible: false,
            obj_spec_tests_labraltearVisible: false,
            obj_spec_tests_lumbarVisible: false,
            obj_spec_tests_lumbarinstabilitycprVisible: false,
            obj_spec_tests_lumbarmanipulationcprVisible: false,
            obj_spec_tests_lumbarmanipulationtestclusterVisible: false,
            obj_spec_tests_muscletoneVisible: false,
            obj_spec_tests_nervetestsVisible: false,
            obj_spec_tests_neurodynamicassessmentVisible: false,
            obj_spec_tests_pelvicvloorassessmentVisible: false,
            obj_spec_tests_pelvicgirdleVisible: false,
            obj_spec_tests_primativereflexesVisible: false,
            obj_spec_tests_protectivereactionsVisible: false,
            obj_spec_tests_reflexesVisible: false,
            obj_spec_tests_rightingreactionsstrategyVisible: false,
            obj_spec_tests_rotatorcufftearclusterVisible: false,
            obj_spec_tests_sensationVisible: false,
            obj_spec_tests_objectmanipulationVisible: false,
            obj_spec_tests_shoulderVisible: false,
            obj_spec_tests_sijclusterVisible: false,
            obj_spec_tests_spinalstenosiscprVisible: false,
            obj_spec_tests_synergiesVisible: false,
            obj_spec_tests_thoracicoutletVisible: false,
            obj_spec_tests_umntestVisible: false,
            obj_spec_tests_visualocularmotorfunctionVisible: false,
            obj_mckenzieVisible: false,
            subj_wcVisible: noteType === 2 ? false : true,
            objectiveVisible: noteType === 2 ? false : true,
            plan_ref_guidelinesVisible: noteType === 2 ? false : true,
            goalsVisible: noteType === 2 ? false : true,
            stgDateDefault: undefined,
        };
        state[action.payload.noteId] = note;
    },
    [noteActions.loadInProgNoteSuccess]: (state, action) => {
        if (state[action.payload.noteId]) {
            state[action.payload.noteId].loading = false;
        }
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        return { ...state, ...action.payload.ui.notes };
    },
    [noteActions.openInProgNoteSuccess]: (state, action) => {
        if (state[action.payload.noteId]) {
            state[action.payload.noteId].loading = false;
        }
    },
    [noteActions.toggleSectionVisibility]: (state, action) => {
        state[action.payload.noteId][action.payload.sectionId.toLowerCase() + 'Visible'] = action.payload.visible;
    },

    [noteActions.goalTemplateDetailsVisible]: (state, action) => {
        state[action.payload.noteId].goalTemplateVisible = !state[action.payload.noteId].goalTemplateVisible;
    },

    [noteActions.getAlTemplateSuccess]: (state, action) => {
        state[action.payload.noteId].alTemplateVisible = true;
        state[action.payload.noteId].alTemplateAllSelected = action.payload.isCustom;
        state[action.payload.noteId].alTmpno = action.payload.tmpno;
    },

    [noteActions.getWpAlTemplateSuccess]: (state, action) => {
        state[action.payload.noteId].alTemplateVisible = true;
        state[action.payload.noteId].alTemplateAllSelected = action.payload.isCustom;
        state[action.payload.noteId].alTmpno = action.payload.tmpno;
    },

    [noteActions.cancelAlTemplate]: (state, action) => {
        state[action.payload].alTemplateVisible = false;
        state[action.payload].alTemplateAllSelected = false;
        state[action.payload].alTmpno = undefined;
    },
    [noteActions.alTemplateToggleAllSelected]: (state, action) => {
        state[action.payload.noteId].alTemplateAllSelected = action.payload.value;
    },
    [noteActions.applyAlTemplateFailure]: (state, action) => {
        state[action.payload.noteId].alTemplateVisible = false;
        state[action.payload.noteId].alTemplateAllSelected = false;
        state[action.payload.noteId].alTmpno = undefined;
    },
    [noteActions.applyAlTemplateSuccess]: (state, action) => {
        state[action.payload.noteId].alTemplateVisible = false;
        state[action.payload.noteId].alTemplateAllSelected = false;
        state[action.payload.noteId].alTmpno = undefined;
    },
    [noteActions.saveAlTemplateSuccess]: (state, action) => {
        state[action.payload.noteId].savePanelVisible = false;
    },
    [noteActions.saveAlTemplateFailure]: (state, action) => {
        state[action.payload.noteId].savePanelVisible = false;
    },
    [noteActions.toggleSaveAlTemplateVisible]: (state, action) => {
        state[action.payload].savePanelVisible = !state[action.payload].savePanelVisible;
    },
    [noteActions.deleteAlTemplateSuccess]: (state, action) => {
        state[action.payload.noteId].lastDeletedAlTemplate = action.payload.xltmpno;
    },
    [noteActions.undoDeleteAlTemplateSuccess]: (state, action) => {
        state[action.payload.noteId].lastDeletedAlTemplate = undefined;
    },
    [noteActions.selectGoal]: (state, action) => {
        state[action.payload.noteId].selectedGoal = action.payload.GONO;
    },
    [noteActions.addGoalSuccess]: (state, action) => {
        state[action.payload.noteId].selectedGoal = action.payload.response.entities.PTGOALS[Object.keys(action.payload.response.entities.PTGOALS)[0]].GONO;
    },
    [noteActions.favoriteGoalSuccess]: (state, action) => {
        state[action.payload.noteId].saveGoalFavoriteVisible = false;
    },
    [noteActions.favoriteGoalFailure]: (state, action) => {
        state[action.payload.noteId].saveGoalFavoriteVisible = false;
    },
    [noteActions.toggleFavoriteGoalVisible]: (state, action) => {
        state[action.payload].saveGoalFavoriteVisible = !state[action.payload].saveGoalFavoriteVisible;
    },
    [noteActions.clearGoalsSuccess]: (state, action) => {
        state[action.payload.noteId].selectedGoal = undefined;
    },
    [noteActions.toggleValidationVisibility]: (state, action) => {
        state[action.payload.noteId].validationVisible = action.payload.visible;
    },
    [noteActions.computeChargesSuccess]: (state, action) => {
        state[action.payload.noteId].computedChargesVisible = true;
    },
    [noteActions.hideComputedCharges]: (state, action) => {
        state[action.payload.noteId].computedChargesVisible = false;
    },
    [noteActions.setNoChargesVisible]: (state, action) => {
        state[action.payload.noteId].noChargesVisible = action.payload.visible;
    },
    [noteActions.saveFinalRequest]: (state, action) => {
        state[action.payload.noteId].savingFinal = true;
    },
    [noteActions.isChargeExist]: (state, action) => {
        state[action.payload.noteId].isChargeExist = true;
        state[action.payload.noteId].savingFinal = false;
    },
    [noteActions.warnAptDate]: (state, action) => {
        state[action.payload.noteId].savingFinal = false;
        state[action.payload.noteId].areYouSure = true;
    },
    [noteActions.clearAptDate]: (state, action) => {
        state[action.payload].savingFinal = false;
        state[action.payload].areYouSure = false;
        state[action.payload].isChargeExist = false;
    },
    [noteActions.saveFinalFailure]: (state, action) => {
        state[action.payload.noteId].savingFinal = false;
    },
    [noteActions.convertRequest]: (state, action) => {
        state[action.payload.noteId].loading = true;
    },
    [noteActions.convertSuccess]: (state, action) => {
        let newNoteId = action.payload.noteType + '_' + action.payload.pk;
        var note = {
            id: newNoteId,
            loading: true,
            alTemplateVisible: false,
            savePanelVisible: false,
            alTmpno: undefined,
            alTemplateAllSelected: false,
            lastDeletedAlTemplate: undefined,
            selectedGoal: undefined,
            saveGoalFavoriteVisible: false,
            validationVisible: false,
            computedChargesVisible: false,
        };
        state[newNoteId] = note;
    },
    [noteActions.convertFailure]: (state, action) => {
        state[action.payload.noteId].loading = false;
    },
    [patientActions.closeTab]: (state, action) => {
        if (action.payload.tabId.startsWith("IN_")) {
            delete state[action.payload.noteId];
        }
    },
    [noteActions.setStgDateDefault]: (state, action) => {
        state[action.payload.noteId].stgDateDefault = action.payload.stgDateDefault;
    },
    [noteActions.getLimberOutcomesRequest]: (state, action) => {
        if (state[action.payload.noteId]) {
            state[action.payload.noteId].limberOutcomesLoading = true;
        }
    },
    [noteActions.getLimberOutcomesSuccess]: (state, action) => {
        if (state[action.payload.noteId]) {
            state[action.payload.noteId].limberOutcomesLoading = false;
        }
    },
    [noteActions.getLimberOutcomesFailure]: (state, action) => {
        if (state[action.payload.noteId]) {
            state[action.payload.noteId].limberOutcomesLoading = false;
        }
    },
})



